import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

var settings = require('../settings/' + process.env.NODE_ENV + '.json')

const options = [
  { path: '/', name: 'Bem-vind@!', component: 'Home', props: false },
  { path: '/trees', name: 'Catálogo de Árvores', component: 'Trees', props: false }
]

const routes = options.map(route => {
  return {
    path: route.path,
    component: () =>
    import(`@/pages/${route.component}.vue`),
    name: route.name,
    props: route.props
  }
})

const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.use(VueAnalytics, {
  id: settings.analytics,
  checkDuplicatedScript: true,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  },
  router
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js